import styled from "styled-components";
import { Alert } from "./Alert";

export const AlertDanger = styled(Alert)`
    color: #842029;
    background-color: #f8d7da;
    border-color: #f5c2c7;
`;
